module.exports = __webpack_public_path__ + "img/img1.5c4b8a72.png";